const handleCommercialPackage = (productList, product, lineItems, packages, discount) => {
  if (packages.length > 0) {
    packages.map((item, index) => {
      product.item_id = product.item_name = `${lineItems[index].description}`;
      product.item_category3 = item.location.state.toUpperCase();
      if (discount > 0 || product.discountPercentage) {
        if (packages.length >= 3 && discount >0) {
          const discountedPrice = lineItems[index].total * 0.1; // discount applied to commercial packages if there is 3 or more
          product.price = Math.round((lineItems[index].total - discountedPrice) * 100) / 100;
          product.coupon = 'Commercial_3_geos';
        } else {
          const discountPrice = lineItems[index].total * product.discountPercentage
          product.price = Math.round((lineItems[index].total - discountPrice) * 100) / 100;
        }
      } else {
        product.price = lineItems[index].total;
      }
      if (item.package === 'lease_expiry_diary') {
        product.item_variant = 'Lease Expiry Diary';
      } else if (item.package === 'cityscope') {
        product.item_variant = 'Cityscope';
      } else if (item.package === 'combo') {
        product.item_variant = 'Cityscope + Lease Expiry Diary';
      }
      delete product.discountPercentage;
      productList.push({ ...product });
    });
  }
};

const handleCommercialConfig = (quote, quoteConfig, category) => {
  const { headLine: packageName, lineItems, minimumInitialTerm, discount } = quote;
  const { packages } = quoteConfig.configuration;

  let product = {};
  const productList = [];

  // Default Values
  product.item_brand = packageName;
  product.item_category = category;
  product.coupon = null;
  product.discountPercentage = quote.provisioningInfo?.discountPercentage
    ? quote.provisioningInfo?.discountPercentage / 100
    : null;

  product.quantity = minimumInitialTerm;
  product.item_category2 = minimumInitialTerm.toString();

  // Handle Commercial Package
  handleCommercialPackage(productList, product, lineItems, packages, discount);

  return productList;
};

export { handleCommercialConfig };
